import React, { useState, useEffect } from "react";
import { PostFieldLabel, PlatformUsage } from "components/Posts/PostForm";
import { FIELDS, GMB_TOPICS, GMB_CTAS } from "constants/PostFormFields";
import PostFieldError from "components/Posts/PostForm/PostFieldError/PostFieldError";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Notification } from "@/components/ui/notification";

const PostCallToAction = ({
  topicType,
  post,
  selectedPlatform,
  platforms,
  disabled = false,
  onChange,
  errors,
  className = "",
}) => {
  const [selected, setSelected] = useState(null);
  useEffect(() => {
    let { gmbCallToAction } = post;
    if (gmbCallToAction && gmbCallToAction.actionType) {
      setSelected(gmbCallToAction.actionType);
    }
  }, []);

  let CTA = GMB_CTAS;

  let config = [
    {
      value: null,
      label: "No button",
    },
    {
      value: CTA.BOOK.VALUE,
      label: CTA.BOOK.LABEL,
    },
    {
      value: CTA.ORDER.VALUE,
      label: CTA.ORDER.LABEL,
    },
    {
      value: CTA.SHOP.VALUE,
      label: CTA.SHOP.LABEL,
    },
    {
      value: CTA.LEARN_MORE.VALUE,
      label: CTA.LEARN_MORE.LABEL,
    },
    {
      value: CTA.SIGN_UP.VALUE,
      label: CTA.SIGN_UP.LABEL,
    },
    {
      value: CTA.CALL.VALUE,
      label: CTA.CALL.LABEL,
    },
  ];

  const handleCtaChange = (item) => {
    const value = item && item.key ? item.key : item;
    // Convert "null" string (from Select component) back to actual null
    const actualValue = value === "null" ? null : value;
    setSelected(actualValue);
    onChange({ [FIELDS.GMB_CTA]: actualValue });
  };

  const forTopics = [
    GMB_TOPICS.STANDARD.VALUE,
    GMB_TOPICS.EVENT.VALUE,
    GMB_TOPICS.ALERT.VALUE,
  ];
  if (!forTopics.includes(topicType)) {
    return "";
  }

  return (
    <div className={className}>
      <div className="flex items-center">
        <PostFieldLabel className="mb-2 mr-4">
          Add a call to action button (optional)
        </PostFieldLabel>
        <PlatformUsage
          platforms={platforms}
          field={FIELDS.GMB_CTA}
          selectedPlatform={selectedPlatform}
        />
      </div>
      <p className="small">
        The call to action button URL will be set to the 'Website or product
        URL' field above.
      </p>
      <Select
        value={selected || undefined}
        onValueChange={handleCtaChange}
        disabled={disabled}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {config.map((option) => (
            <SelectItem
              key={option.value || "null"}
              value={option.value || "null"}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {!topicType && (
        <Notification
          variant="error"
          className="mt-2"
          title="Pick a topic type to enter other GMB values."
        />
      )}
      <PostFieldError
        className="mt-4"
        fields={[FIELDS.GMB_CTA]}
        errors={errors}
      />
    </div>
  );
};

export default PostCallToAction;
